<template>
	<edit></edit>
</template>

<script>
	import edit from './global_reward_edit.vue'
	
	export default {
		name: 'global_reward_add',
		
		components: {
			edit
		}
	}
</script>